import { Dialog } from "@headlessui/react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Swal from "sweetalert2";
import GlobalForm from "../../components/globalForm/GlobalForm";
import Modal from "../../components/shared/modal/Modal";
import Navbar from "../../components/shared/navbar/Navbar";
import { deleteData } from "../../hooks/delete";
import { updateData } from "../../hooks/update";
import useFetch from "../../hooks/useFetch";
import { apiPath } from "../../utility/Constant";
import UserTable from "./UserTable";

function UsersList() {
  const { userListApi } = apiPath;
  const [data, loading] = useFetch(userListApi);
  const [modalData, setModalData] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [submitType, setSubmitType] = useState(""); // add | update
  const [activeItemId, setActiveItemId] = useState(); // add | update
  const navigate = useNavigate();

  const refreshPage = () => {
    navigate(0);
  };

  function closeModal() {
    setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
  }

  const newUserData = [
    {
      elementType: "input",
      label: "username",
      type: "Text",
      name: "name",
      fullCol: true,
      required: true,
      // pattern: /^[a-z0-9_.]+$/,
    },
    {
      elementType: "input",
      label: "email",
      type: "email",
      name: "email",
      fullCol: true,
      required: true,
    },
    {
      elementType: "select",
      label: "role",
      type: "Text",
      name: "role",
      required: true,
    },
    {
      elementType: "input",
      label: "new password",
      type: "password",
      name: "password",
      required: true,
      fullCol: true,
      // info: true,
    },
  ];
  const oldUserData = (data) => {
    return [
      {
        elementType: "input",
        label: "username",
        type: "Text",
        name: "name",
        fullCol: true,
        defaultValue: data?.name,
        required: false,
        // pattern: /^[a-z0-9_.]+$/,
      },
      {
        elementType: "input",
        label: "email",
        type: "email",
        name: "email",
        defaultValue: data?.email,
        fullCol: true,
        required: false,
      },
      {
        elementType: "select",
        label: "role",
        type: "Text",
        name: "role",
        defaultValue: data?.role,
        fullCol: true,
        required: false,
      },
      {
        elementType: "select",
        label: "status",
        type: "Text",
        name: "status",
        defaultValue: data?.status,
        fullCol: true,
        required: false,
        options: ["active", "inactive"],
      },
      {
        elementType: "input",
        label: "new password",
        type: "password",
        name: "password",
        defaultValue: data?.password,
        required: false,
        fullCol: true,
        // info: true,
      },
    ];
  };

  function handleAddNewUser() {
    setSubmitType("add");
    setModalData(newUserData);
    openModal();
  }

  function handleUserEdit(userData) {
    setActiveItemId(userData._id);
    setSubmitType("update");
    setModalData(oldUserData(userData));
    openModal();
  }

  const update = async (data) => {
    if (submitType === "add") {
      const res = await updateData("user/create", data, null, true);
      closeModal();
      res.length > 0 && refreshPage();
    } else if (submitType === "update") {
      const res = await updateData(
        "user/list",
        data,
        activeItemId,
        null,
        null,
        null,
        true
      );
      closeModal();
      res.length > 0 && refreshPage();
    }
  };

  // delete single user
  async function handleSingleDelete(id) {
    const swalResponse = await Swal.fire({
      title: "Are you sure you want to delete this?",
      showCancelButton: true,
      confirmButtonText: "Delete",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        return await deleteData(userListApi, id);
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });
    return swalResponse?.value?.data._id?.length > 0;
  }

  return (
    <>
      <Navbar adminPage={true} />
      <Modal isOpen={isOpen} closeModal={closeModal}>
        <Dialog.Title
          as="h3"
          className="text-2xl text-center font-bold leading-6 text-gray-700 capitalize mb-4 md:mt-8 md:-mb-12"
        >
          {submitType} User
        </Dialog.Title>
        <GlobalForm
          data={modalData}
          update={update}
          updateBtn={submitType === "update"}
        />
      </Modal>
      <div className="w-full min-h-[81vh] md:h-[84vh] flex justify-center mb-5 -mt-32 md:-mt-32 px-5 md:px-20">
        <div className="w-full bg-white shadow-xl rounded-2xl p-4 md:p-10 overflow-hidden">
          <h1 className="font-bold text-2xl text-center mb-4 md:mb-8 mt-2 md:mt-0 uppercase">
            All user
          </h1>
          <UserTable
            data={data.data}
            handleUserEdit={handleUserEdit}
            handleSingleDelete={handleSingleDelete}
          />
          <div>
            <button
              onClick={handleAddNewUser}
              className="group fixed bottom-12 md:bottom-20 right-8 md:right-12 bg-[#DB0029] hover:px-6 min-w-[3.5rem] md:min-w-[4rem] max-w-[4rem] hover:max-w-[10rem] h-14 md:h-16 rounded-full flex items-center shadow-xl justify-center gap-4 text-white transition-all duration-200 ease-in-out"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-5 h-5 md:w-8 md:h-8"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 4.5v15m7.5-7.5h-15"
                />
              </svg>
              <span className="hidden group-hover:block text-lg text-white  transition-all duration-200 ease-in-out">
                ADD
              </span>
            </button>
          </div>
        </div>
      </div>
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
}

export default UsersList;
